import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import type Mithril from 'mithril';

export default class ComposerPage extends Page {
  oninit(vnode: Mithril.Vnode) {
    super.oninit(vnode);

    if (!app.session.user) {
      return m.route.set('/');
    }

    const params = m.route.param();

    m.route.set('/all');

    setTimeout(() => {
      let composerProps = {
        user: app.session.user,
      };

      if (params.content) {
        // @ts-ignore
        composerProps.originalContent = params.content;
      }

      app.composer.load(DiscussionComposer, composerProps);

      app.composer.show();

      if (params.title) {
        // @ts-ignore
        app.composer.fields.title(params.title);
      }

      if (params.primary_tag) {
        // @ts-ignore
        const tag = app.store.getBy('tags', 'slug', params.primary_tag);

        if (tag) {
          // @ts-ignore
          const parent = tag.parent();

          // @ts-ignore
          app.composer.fields.tags = parent ? [parent, tag] : [tag];
        }
      }
    }, 0);
  }

  view() {
    return <div></div>;
  }
}
